<div class="d-flex account-on-hold text-left p-3">
    You have past due invoices and your account has been placed on a credit hold. Please contact
    <a [href]="'mailto:collections@cargosprint.com' | sanitize: 'url'" class="foreground-primary-darker">
        collections&#64;cargosprint.com </a
    >for support.
</div>
